module.exports = __webpack_public_path__ + "static/carne200-038cb20296732a72bb56075aabcf7693.png";